import { create } from "zustand";

// ✅ CORRIGIDO: Store Zustand configurado corretamente para v4
// O Zustand v4 não precisa de Provider quando usado com create()
// Mas garantimos que o store está bem configurado
export const useNodeStorage = create((set, get) => ({
  node: "",
  connect: "",
  action: "idle",
  setNodesStorage: (node) => set((state) => ({ ...state, node: node })),
  setConnectsStorage: (connects) =>
    set((state) => ({ ...state, connect: connects })),
  setAct: (act) => set((state) => ({ ...state, action: act }))
}));
